import { getSdk } from "../services/sdkService";

export async function getPreferredLanguage() {
  const sdk = await getSdk();
  let preferredLanguage = await sdk.userManager.getPreferences();
  if (Object.keys(preferredLanguage).length === 0) {
    preferredLanguage = {
      playback: {
        subtitles: "en",
        audio: "en"
      }
    };
  } else {
    preferredLanguage.playback = preferredLanguage.playback || {};

    if (!("subtitles" in preferredLanguage.playback)) {
      preferredLanguage.playback.subtitles = "en";
    }

    if (!("audio" in preferredLanguage.playback)) {
      preferredLanguage.playback.audio = "en";
    }
  }
  return preferredLanguage;
}

// Default preference if guest mode or preference is missing
export function getDefaultPreferredLanguage(prefLanguage = {}) {
  const playback =
    typeof prefLanguage.playback === "object" && prefLanguage.playback !== null ? prefLanguage.playback : {};

  return {
    ...prefLanguage,
    playback: {
      ...playback,
      subtitles: playback.subtitles ?? "en",
      audio: playback.audio ?? "en"
    }
  };
}
